// src/components/Map.jsx
import React, { useRef } from 'react';
import 'leaflet/dist/leaflet.css';
import { useMap } from '../hooks/useMap';

export default function Map({ entries = [], colors = {}, liveLocations = [] }) {
  const mapContainer = useRef(null);

  const safeEntries = Array.isArray(entries) ? entries : [];
  const safeColors  = (colors && typeof colors === 'object') ? colors : {};
  const safeLive    = Array.isArray(liveLocations) ? liveLocations : [];

  try {
    useMap(mapContainer, safeEntries, safeColors, { liveLocations: safeLive });
  } catch (err) {
    console.error('useMap crash prevented:', err);
    return <div style={{ height: 0 }} aria-hidden="true" />;
  }

  return (
    <div
      ref={mapContainer}
      style={{
        height: '400px',
        minHeight: '400px',
        margin: '1rem 0',
        backgroundColor: '#eee',
        borderRadius: '12px',
        overflow: 'hidden'
      }}
    />
  );
}
